import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Create,
  CreateProps,
  FormDataConsumer,
  ListButton,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { CreateFileRequest } from '../../../core/files/files.provider'
import { FileInput } from './forms/FileInput'

const validateFileCreate = (values: CreateFileRequest) => {
  const errors: { [n: string]: string } = {}
  if (!values.file) {
    errors.file = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.files.titles.create')}</span>
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const FileCreate = (props: CreateProps) => (
  <Create {...props} title={<CreateTitle />}>
    <SimpleForm
      redirect="show"
      validate={validateFileCreate}
      toolbar={<CreateToolbar />}
    >
      <TextInput source="name" fullWidth />
      <FormDataConsumer fullWidth>
        {({ formData, ...formRest }) => (
          <FileInput
            {...formRest}
            formData={formData}
            fullWidth
            source="file"
          />
        )}
      </FormDataConsumer>
    </SimpleForm>
  </Create>
)
